/**
 * DS Cart Upsell v2 – Cross-Sell im Apple Header Cart Pane
 *
 * Injiziert eine kompakte Cross-Sell-Zeile in den Apple Header Cart Pane (sn-cart-pane).
 * Holt frische Upsell-Daten via Shopify Section Rendering API nach jedem Cart-Change.
 * Initiale Config aus server-gerendertem JSON (falls Cart bei Page-Load gefuellt).
 *
 * Architektur:
 * - ajaxProduct:added → fetchUpsellConfig() via Section Rendering API
 * - MutationObserver auf sn-cart-content-area → injectUpsell() bei Cart-Render
 * - Badge-Update: NICHT hier – wird vom Apple Header Listener erledigt
 *
 * SICHERHEIT:
 * - Alle dynamischen Werte stammen aus server-gerendertem JSON-Config (Liquid)
 * - Text-Inhalte werden via textContent gesetzt (kein innerHTML fuer User-Daten)
 * - SVG-Icons: nur ICON_CHECK (hardcoded Konstante)
 * - variantId wird als parseInt() validiert
 */
(function() {
  'use strict';

  // ── State ─────────────────────────────────────────────────────────
  var currentConfig = null;
  var pendingRefresh = false;
  var injected = false;
  var upsellWasVisible = false; // Track if upsell was visible before re-render

  // ── Initial Config aus DOM lesen (falls vorhanden) ────────────────
  var cfgEl = document.querySelector('[data-ds-upsell-config]');
  if (cfgEl) {
    try {
      var parsed = JSON.parse(cfgEl.textContent);
      if (parsed && parsed.variantId) currentConfig = parsed;
    } catch (e) { /* ignore */ }
  }

  // ── Icons (hardcoded SVG constants) ───────────────────────────────
  var ICON_CHECK = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';

  var SPINNER_CLASS = 'ds-upsell__btn--loading';

  // ── CSS (scoped auf [data-ds-upsell] → nur Drawer, nicht Cart-Page) ──
  var STYLE = ''
    // Drawer Upsell: hidden by default, zero space (Bug A: kein Layout-Shift)
    + '.ds-upsell[data-ds-upsell]{padding:0;margin:0;'
    + 'border-top:0px solid #e5e5e5;'
    + 'opacity:0;max-height:0;overflow:hidden;'
    + 'transition:opacity .3s ease .1s,max-height .4s ease,padding .3s ease,margin .3s ease,border-top-width .3s ease;}'
    // Visible: expand + fade in
    + '.ds-upsell[data-ds-upsell].ds-upsell--visible{opacity:1;max-height:200px;'
    + 'padding:16px 0 0;margin-top:16px;border-top-width:1px;}'
    // Collapsed: nach Upsell-Add
    + '.ds-upsell[data-ds-upsell].ds-upsell--collapsed{opacity:0;max-height:0;padding:0;margin:0;'
    + 'border-top-width:0;transition:opacity .3s ease,max-height .4s ease,padding .3s ease,margin .3s ease;}'
    // Scoped child elements (Bug B: kein Leak auf Cart-Page)
    + '.ds-upsell[data-ds-upsell] .ds-upsell__hdr{font-size:12px;font-weight:500;color:#86868b;'
    + 'text-transform:none;letter-spacing:0;margin-bottom:12px;}'
    + '.ds-upsell[data-ds-upsell] .ds-upsell__row{display:flex;align-items:center;gap:12px;}'
    // 64px statt 48px (GF 04.08.2026): die Produktfotos sind 3:2 und tragen weissen Rand.
    // Bei 48px blieb vom Motiv (Hundebar) noch etwa 38x20px uebrig, das war nicht erkennbar.
    // Rahmen + heller Grund wie beim Cross-Sell-Reminder darueber, damit die Kachel als
    // Produktbild lesbar ist. Die Zeilenhoehe waechst dadurch nicht: der Textblock
    // daneben ist mit rund 96px ohnehin hoeher.
    + '.ds-upsell[data-ds-upsell] .ds-upsell__img{width:64px;height:64px;border-radius:8px;'
    + 'object-fit:contain;background:#fff;border:1px solid #e5e5e5;box-sizing:border-box;'
    + 'flex-shrink:0;}'
    + '.ds-upsell[data-ds-upsell] .ds-upsell__info{flex:1;min-width:0;}'
    + '.ds-upsell[data-ds-upsell] .ds-upsell__name{font-size:14px;font-weight:400;'
    + 'color:var(--sn-card-text,#1d1d1f);line-height:1.3;display:block;text-decoration:none;}'
    + '.ds-upsell[data-ds-upsell] .ds-upsell__name:hover{color:var(--sn-color-hover,#0071e3);}'
    // text-align und width stehen hier ausdruecklich, weil dieser Block in fremde
    // Seiten injiziert wird. Die Cart-Seite hatte dieselben Klassennamen ungescoped
    // stehen und zog den Preis auf /cart in die Mitte.
    + '.ds-upsell[data-ds-upsell] .ds-upsell__price{font-size:13px;font-weight:500;color:var(--sn-card-text,#1d1d1f);margin-top:4px;white-space:nowrap;text-align:left;width:auto;}'
    + '.ds-upsell[data-ds-upsell] .dsu__rot{min-height:32px;display:flex;align-items:center;overflow:hidden;margin-top:3px;}'
    + '.ds-upsell[data-ds-upsell] .dsu__rot-line{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;font-size:11px;color:#86868b;line-height:16px;overflow:hidden;transition:opacity .35s ease;}'
    + '.ds-upsell[data-ds-upsell] .ds-upsell__btn{display:inline-flex;align-items:center;gap:4px;'
    + 'background:var(--sn-cta-bg,#1d1d1f);color:var(--sn-cta-text,#fff);'
    + 'border:none;border-radius:99px;padding:5px 12px;font-size:12px;font-weight:500;'
    + 'cursor:pointer;transition:opacity .2s;white-space:nowrap;font-family:inherit;flex-shrink:0;}'
    + '.ds-upsell[data-ds-upsell] .ds-upsell__btn:hover{opacity:0.85;}'
    + '.ds-upsell[data-ds-upsell] .ds-upsell__btn:disabled{opacity:0.5;cursor:default;}'
    + '.ds-upsell[data-ds-upsell] .ds-upsell__btn--success{background:#63C132;}'
    + '.ds-upsell[data-ds-upsell] .ds-upsell__btn--loading{opacity:0.6;}'
    + '@keyframes ds-spin{to{transform:rotate(360deg)}}'
    + '.ds-upsell__spinner{display:inline-block;width:12px;height:12px;'
    + 'border:2px solid currentColor;border-top-color:transparent;border-radius:50%;'
    + 'animation:ds-spin .6s linear infinite;}'
    // Cart pane polish
    + '.sn-cart-img{border-radius:8px;}'
    // Legacy Drawer unterdruecken
    + '#CartDrawer{display:none!important;}'
    // Bug C2: Einkaufstasche Titel schwarz
    + '.sn-cart-header{color:#1d1d1f!important;}'
    // Bug C1: Mobile linksbuendig (Breakpoint 999px, nicht 425px)
    // ID-Selektor schlaegt Apple Header's Class-Selektor (Specificity > Source Order)
    + '@media(max-width:999px){'
    + '#sn-cart-content-area .sn-cart-list{text-align:left!important;align-items:stretch!important;}'
    + '#sn-cart-content-area .sn-cart-details{text-align:left!important;}'
    + '#sn-cart-content-area .sn-cart-bottom{text-align:left!important;align-items:stretch!important;}'
    + '#sn-cart-content-area .sn-quick-links{align-items:flex-start!important;}'
    + '.ds-upsell[data-ds-upsell]{text-align:left;order:3;}'
    + '}';

  // ── Inject Style ──────────────────────────────────────────────────
  var styleEl = document.createElement('style');
  styleEl.textContent = STYLE;
  document.head.appendChild(styleEl);

  // ── Section Rendering API: frische Config holen ───────────────────
  function fetchUpsellConfig() {
    return fetch('/?sections=ds-cart-upsell-data')
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        var html = sections['ds-cart-upsell-data'];
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector('[data-ds-upsell-config]');
        if (!el) return null;
        try {
          var cfg = JSON.parse(el.textContent);
          return (cfg && cfg.variantId) ? cfg : null;
        } catch (e) { return null; }
      })
      .catch(function() { return null; });
  }

  // ── Build Cross-Sell Element ──────────────────────────────────────
  function buildElement(config) {
    var container = document.createElement('div');
    container.className = 'ds-upsell';
    container.setAttribute('data-ds-upsell', '');
    container.setAttribute('data-ds-upsell-product-id', String(config.productId));

    // Header (dynamic headline, kein Icon)
    var hdr = document.createElement('div');
    hdr.className = 'ds-upsell__hdr';
    hdr.textContent = config.upsellHeadline || 'Dazu passt:';
    container.appendChild(hdr);

    // Product row
    var row = document.createElement('div');
    row.className = 'ds-upsell__row';

    var img = document.createElement('img');
    img.className = 'ds-upsell__img';
    img.src = config.image;
    img.alt = config.title;
    img.width = 64;
    img.height = 64;
    img.loading = 'lazy';

    var info = document.createElement('div');
    info.className = 'ds-upsell__info';

    var nameLink = document.createElement('a');
    nameLink.className = 'ds-upsell__name';
    nameLink.href = config.url;
    nameLink.textContent = config.title;
    nameLink.addEventListener('click', function() { // Änderung B: upsell_click tracking
      pushEvent('upsell_click', {
        upsell_product_id: config.productId,
        upsell_product_title: config.title,
        main_product_id: config.sourceProductId || null,
        main_product_title: config.sourceProductTitle || '',
        location: 'cart_drawer',
            upsell_variante: config.upsellVariante || 'standard'
          });
    });

    var price = document.createElement('div');
    price.className = 'ds-upsell__price';
    price.textContent = config.price;

    info.appendChild(nameLink);
    // Reihenfolge wie auf der Cart-Seite: Titel, Bullets, Preis. Der Preis wird unten
    // angehaengt, NICHT hier, sonst steht er zwischen Titel und Nutzen.

    // Rotierende Benefit-Zeile (statt mehrzeiligem ul) – Animation via assets/ds-upsell-rotator.js
    if (config.upsellBullets) {
      var rotLines = [];
      var ub = config.upsellBullets;
      if (Array.isArray(ub)) {
        // Regelfall: Liquid liefert eine fertige Liste (snippets/ds-upsell-bullets.liquid)
        rotLines = ub.map(function (s) { return String(s).trim(); }).filter(Boolean);
      } else if (typeof ub === 'string') {
        // Uebergangsfall: alte, noch gecachte Config mit Multiline-Text
        rotLines = ub.split('\n').map(function (s) { return s.trim(); }).filter(Boolean);
      }
      if (rotLines.length) {
        var rot = document.createElement('div');
        rot.className = 'dsu__rot';
        rot.setAttribute('data-upsell-rotator', '');
        rot.setAttribute('data-bullets', JSON.stringify(rotLines));
        var rl = document.createElement('span');
        rl.className = 'dsu__rot-line';
        rl.textContent = rotLines[0];
        rot.appendChild(rl);
        info.appendChild(rot);
        // ds-upsell-rotator.js startet die Rotation automatisch (MutationObserver)
      }
    }
    info.appendChild(price);
    // Footnote im Drawer entfernt (Platz sparen, konsistent zur Cart-Seite)

    var btn = document.createElement('button');
    btn.className = 'ds-upsell__btn';
    btn.setAttribute('data-ds-upsell-btn', '');
    btn.setAttribute('data-variant-id', String(config.variantId));

    var btnText = document.createElement('span');
    btnText.textContent = 'Hinzuf\u00fcgen';
    btn.appendChild(btnText);

    row.appendChild(img);
    row.appendChild(info);
    row.appendChild(btn);
    container.appendChild(row);

    return container;
  }

  // ── Inject/Update Upsell in Cart Pane ─────────────────────────────
  function injectUpsell(config) {
    var area = document.getElementById('sn-cart-content-area');
    if (!area) return;

    // Bug 2 Safety Net: cartProductIds (Array aus Liquid JSON) gegen productId pruefen
    // cartProductIds wird in ds-cart-upsell-data.liquid / ds-cart-upsell.liquid als JSON-Array ausgegeben
    if (config && config.productId && config.cartProductIds) {
      if (config.cartProductIds.indexOf(config.productId) !== -1) {
        config = null;
      }
    }

    // Track visibility before removing
    var existing = area.querySelector('[data-ds-upsell]');
    if (existing) {
      if (existing.classList.contains('ds-upsell--visible')) upsellWasVisible = true;
      existing.remove();
    }

    // No config or no valid data → done
    if (!config || !config.variantId || !config.title) return;

    var cartTop = area.querySelector('.sn-cart-top');
    if (!cartTop) return;

    var cartList = cartTop.querySelector('.sn-cart-list');
    if (!cartList) return;

    var el = buildElement(config);
    cartList.parentNode.insertBefore(el, cartList.nextSibling);

    if (upsellWasVisible) {
      // Was already visible before re-render → show immediately (no twitch)
      el.classList.add('ds-upsell--visible');
      // Änderung D: Guard ist hier immer false (upsellWasVisible=true) – kein Re-Impression bei Re-Render
      if (!upsellWasVisible) {
        upsellWasVisible = true;
        pushEvent('upsell_impression', {
          upsell_product_id: config.productId,
          upsell_product_title: config.title,
          upsell_price: +(config.priceCents / 100).toFixed(2),
          main_product_id: config.sourceProductId || null,
          main_product_title: config.sourceProductTitle || '',
          location: 'cart_drawer',
          upsell_variante: config.upsellVariante || 'standard'
        });
        if (typeof clarity === 'function') {
          clarity('set', 'upsell_shown', 'true');
          clarity('set', 'upsell_product', config.handle || '');
        }
      }
    } else {
      // First appearance → smooth expand after drawer animation finishes
      var expandDelay = window.innerWidth <= 999 ? 800 : 200;
      setTimeout(function() {
        requestAnimationFrame(function() {
          el.classList.add('ds-upsell--visible');
          // Änderung A: Guard verhindert Doppel-Impression wenn Drawer mehrfach geöffnet
          if (!upsellWasVisible) {
            upsellWasVisible = true;
            pushEvent('upsell_impression', {
              upsell_product_id: config.productId,
              upsell_product_title: config.title,
              upsell_price: +(config.priceCents / 100).toFixed(2),
              main_product_id: config.sourceProductId || null,
              main_product_title: config.sourceProductTitle || '',
              location: 'cart_drawer',
              upsell_variante: config.upsellVariante || 'standard'
            });
            if (typeof clarity === 'function') {
              clarity('set', 'upsell_shown', 'true');
              clarity('set', 'upsell_product', config.handle || '');
            }
          }
        });
      }, expandDelay);
    }

    injected = true;
  }

  // ── Observe sn-cart-content-area for Apple Header cart renders ────
  function observeArea(area) {
    var observer = new MutationObserver(function() {
      injected = false;
      injectUpsell(currentConfig);
    });
    observer.observe(area, { childList: true, subtree: false });
    // Initial inject if area already has content
    if (area.children.length > 0) {
      injectUpsell(currentConfig);
    }
  }

  // ── MutationObserver Setup ────────────────────────────────────────
  // sn-cart-content-area is created dynamically by Apple Header JS.
  // Strategy: if found → observe directly; if not → watch body until
  // it appears, then switch to the specific observer.
  var area = document.getElementById('sn-cart-content-area');
  if (area) {
    observeArea(area);
  } else {
    var bodyObs = new MutationObserver(function() {
      var a = document.getElementById('sn-cart-content-area');
      if (!a) return;
      bodyObs.disconnect();
      observeArea(a);
    });
    bodyObs.observe(document.body, { childList: true, subtree: true });
  }

  // ── cart:rendered → Reliable injection point (fired by Apple Header after every render) ──
  document.addEventListener('cart:rendered', function() {
    injected = false;
    if (currentConfig && !pendingRefresh) {
      injectUpsell(currentConfig);
    }
  });

  // ── ajaxProduct:added → Fetch fresh config ────────────────────────
  document.addEventListener('ajaxProduct:added', function() {
    pendingRefresh = true; // Block cart:rendered from injecting with stale config
    // Fetch with retry: if first attempt fails, retry once after 500ms
    fetchUpsellConfig().then(function(config) {
      if (config) {
        currentConfig = config;
        pendingRefresh = false;
        // Inject immediately if cart area is ready
        var a = document.getElementById('sn-cart-content-area');
        if (a && a.children.length > 0) {
          injectUpsell(currentConfig);
        }
      } else {
        // Retry once after 500ms (Section Rendering API may be slow)
        setTimeout(function() {
          fetchUpsellConfig().then(function(retryConfig) {
            if (retryConfig) {
              currentConfig = retryConfig;
              pendingRefresh = false;
              var a = document.getElementById('sn-cart-content-area');
              if (a && a.children.length > 0) {
                injectUpsell(currentConfig);
              }
            } else {
              // Fix 4: No upsell available – clear stale config + remove DOM
              currentConfig = null;
              pendingRefresh = false;
              var staleEl = document.querySelector('[data-ds-upsell]');
              if (staleEl) {
                staleEl.classList.remove('ds-upsell--visible');
                staleEl.classList.add('ds-upsell--collapsed');
                upsellWasVisible = false;
              }
            }
          });
        }, 500);
      }
    });

    // Fallback: re-inject after cart content has settled (race condition safety net)
    setTimeout(function() {
      var a = document.getElementById('sn-cart-content-area');
      if (a && a.children.length > 0 && !a.querySelector('[data-ds-upsell]') && currentConfig && !pendingRefresh) {
        injectUpsell(currentConfig);
      }
    }, 1500);

    // Second fallback: catch very slow renders
    setTimeout(function() {
      var a = document.getElementById('sn-cart-content-area');
      if (a && a.children.length > 0 && !a.querySelector('[data-ds-upsell]') && currentConfig && !pendingRefresh) {
        injectUpsell(currentConfig);
      }
    }, 3000);
  });

  // ── Click Handler (Event Delegation) ──────────────────────────────
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-ds-upsell-btn]');
    if (!btn || btn.disabled) return;

    e.preventDefault();
    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!variantId || isNaN(variantId)) return;

    // Loading state
    btn.disabled = true;
    btn.classList.add(SPINNER_CLASS);
    var btnSpan = btn.querySelector('span');
    if (btnSpan) {
      btnSpan.textContent = '';
      var spinner = document.createElement('span');
      spinner.className = 'ds-upsell__spinner';
      btn.insertBefore(spinner, btnSpan);
    }

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-DS-Source': 'upsell' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { '_upsell': '1' } }] })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('Add failed: ' + r.status);
      return r.json();
    })
    .then(function() {
      // Success state
      btn.classList.remove(SPINNER_CLASS);
      btn.classList.add('ds-upsell__btn--success');
      var spinEl = btn.querySelector('.ds-upsell__spinner');
      if (spinEl) {
        var tmp = document.createElement('span');
        tmp.innerHTML = ICON_CHECK; // safe: hardcoded constant
        spinEl.parentNode.replaceChild(tmp.firstChild, spinEl);
      }
      var textSpan = btn.querySelector('span');
      if (textSpan) textSpan.textContent = 'Hinzugef\u00fcgt';

      // Dispatch event for theme cart refresh + shipping bar update
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));

      // dataLayer tracking (Änderung C: upsell_product_id, main_product_id, location hinzugefügt)
      pushEvent('ds_upsell_added', {
        upsell_product_id: currentConfig ? currentConfig.productId : null,
        main_product_id: currentConfig ? (currentConfig.sourceProductId || null) : null,
        main_product_title: currentConfig ? (currentConfig.sourceProductTitle || '') : '',
        ds_upsell_product: currentConfig ? currentConfig.title : '',
        ds_upsell_variant_id: variantId,
        ds_upsell_value: currentConfig ? +(currentConfig.priceCents / 100).toFixed(2) : 0,
        location: 'cart_drawer',
        upsell_variante: currentConfig ? (currentConfig.upsellVariante || 'standard') : 'standard'
      });
      if (typeof clarity === 'function') {
        clarity('set', 'upsell_converted', 'true');
      }

      // Collapse after 1.5s – store reference so we only collapse THIS element,
      // not a newly injected upsell that may have replaced it
      var collapseTarget = btn.closest('[data-ds-upsell]');
      setTimeout(function() {
        if (collapseTarget && collapseTarget.parentNode) {
          collapseTarget.classList.remove('ds-upsell--visible');
          collapseTarget.classList.add('ds-upsell--collapsed');
          upsellWasVisible = false; // Reset so next upsell gets expand animation
        }
      }, 1500);
    })
    .catch(function(err) {
      console.error('DS Upsell: Add to cart failed', err);
      btn.disabled = false;
      btn.classList.remove(SPINNER_CLASS);
      var spinEl = btn.querySelector('.ds-upsell__spinner');
      if (spinEl) spinEl.remove();
      var textSpan = btn.querySelector('span');
      if (textSpan) textSpan.textContent = 'Hinzuf\u00fcgen';
    });
  });

  // ── Tracking Helper ───────────────────────────────────────────────
  function pushEvent(name, params) {
    window.dataLayer = window.dataLayer || [];
    var evt = { event: name };
    for (var key in params) {
      if (params.hasOwnProperty(key)) evt[key] = params[key];
    }
    window.dataLayer.push(evt);
  }

})();